export default __webpack_public_path__ + "static/media/cashier-active.97eba82c.svg";